/* Unaklo lens color grouping — sorts Lens Color pills by color family with group labels */
(function(){
  var GROUPS = [
    { name: "Reds & Oranges", colors: ["Ruby","Ruby Iridium","Orange Ruby","Red Orange","Fire Iridium","Orange","Orange Polarized","Orange Fire Polarized","Blaze Orange Polarized","Sunset Orange Polarized","Burnt Orange"] },
    { name: "Yellows & Golds", colors: ["Golden Yellow","Yellow","Yellow Polarized","Yellow Iridium Polarized","Gold Iridium","Lime Polarized","Yellow Green Polarized"] },
    { name: "Greens", colors: ["Green"] },
    { name: "Blues", colors: ["Sky Blue","Blue Polarized","Grey Polarized"] },
    { name: "Purples & Pinks", colors: ["Purple","Purple Fade Polarized","Purple Blue","Pink","Pink Polarized"] },
    { name: "Neutrals", colors: ["Brown","Silver Polarized","Black","Black Polarized","Mirror Black","Stealth Black"] }
  ];
  var order = {};
  GROUPS.forEach(function(g, gi){
    g.colors.forEach(function(c, ci){ order[c] = gi * 100 + ci; });
  });

  function cleanLabelText(label){
    var clone = label.cloneNode(true);
    clone.querySelectorAll(".visually-hidden").forEach(function(s){ s.remove(); });
    return clone.textContent.trim();
  }

  function apply(){
    document.querySelectorAll("fieldset").forEach(function(fs){
      if(fs.dataset.unakloGrouped) return;
      var legend = fs.querySelector("legend");
      if(!legend) return;
      if(legend.textContent.trim().indexOf("Lens Color") !== 0) return;
      var pairs = [];
      fs.querySelectorAll("label").forEach(function(label){
        var input = label.htmlFor ? document.getElementById(label.htmlFor) : null;
        var val = cleanLabelText(label);
        pairs.push({ input: input, label: label, key: (val in order) ? order[val] : 9999, val: val });
      });
      if(pairs.length < 2) return;
      pairs.sort(function(a,b){ return a.key - b.key; });
      pairs.forEach(function(p){
        if(p.input) p.input.remove();
        p.label.remove();
      });
      var frag = document.createDocumentFragment();
      var lastGroup = -1;
      pairs.forEach(function(p){
        var gi = Math.floor(p.key / 100);
        if(gi !== lastGroup && gi < GROUPS.length){
          var div = document.createElement("div");
          div.className = "unaklo-lens-group";
          div.textContent = GROUPS[gi].name;
          frag.appendChild(div);
          lastGroup = gi;
        }
        if(p.input) frag.appendChild(p.input);
        frag.appendChild(p.label);
      });
      fs.appendChild(frag);
      fs.dataset.unakloGrouped = "1";
    });
  }
  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", apply);
  } else { apply(); }
})();
